import { Component } from '@angular/core';
import { PubService } from '../../../services/pub.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-pubs-landing-page',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class PubsLandingPageComponent {

  loading = false;
  error = '';

  placementsData: { [key: string]: any[] } = {};

  placementLimits: { [key: string]: number } = {
    Homepage: 1,
    Sidebar: 3,
    DealsSection: 6,
  };

  uniqueCategories: string[] = [];
  categorySlides: string[][] = [];
  itemsPerSlide = 6;

  constructor(
    private pubService: PubService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.fetchListings();
  }

  async fetchListings() {
    this.loading = true;
    this.error = '';

    try {
      const result = await firstValueFrom(this.pubService.list());
      let records = result.records || [];

      // ✅ Latest first
      records.sort(
        (a: any, b: any) =>
          new Date(b.createdAt || b.timestampedAt).getTime() -
          new Date(a.createdAt || a.timestampedAt).getTime()
      );

      this.placementsData = {};
      const categorySet = new Set<string>();

      records.forEach((item: any) => {

        let placement = item.placement;
        // Default to 'Deals Section' if no placement is set
        if (!placement || !placement.trim()) {
          placement = 'Deals Section';
        }

        const limit = this.placementLimits[placement] ?? Infinity;

        if (!this.placementsData[placement]) {
          this.placementsData[placement] = [];
        }

        // Only add if we haven't hit the limit (or no limit)
        if (this.placementsData[placement].length < limit) {
          this.placementsData[placement].push(item);
        }

        if (item.category) {
          categorySet.add(item.category.trim());
        }
      });

      this.uniqueCategories = Array.from(categorySet);
      this.prepareCategorySlides();

    } catch (err) {
      console.error(err);
      this.error = 'Failed to load data. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  prepareCategorySlides() {
    this.categorySlides = [];
    for (let i = 0; i < this.uniqueCategories.length; i += this.itemsPerSlide) {
      this.categorySlides.push(
        this.uniqueCategories.slice(i, i + this.itemsPerSlide)
      );
    }
  }

}
